export default __webpack_public_path__ + "static/media/become-distributor_new.671808f1.svg";